import { render, staticRenderFns } from "./asks.vue?vue&type=template&id=35125633&"
import script from "./asks.vue?vue&type=script&lang=js&"
export * from "./asks.vue?vue&type=script&lang=js&"
import style0 from "./asks.vue?vue&type=style&index=0&id=35125633&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports